(function () {
    function getRootUrl() {
        if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
            return window.Shopify.routes.root;
        }

        return '/';
    }

    function createMoneyFormatter(currency) {
        var locale = document.documentElement.lang || 'pt-BR';

        try {
            return new Intl.NumberFormat(locale, {
                style: 'currency',
                currency: currency || 'BRL'
            });
        } catch (error) {
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            });
        }
    }

    function formatMoney(cents, currency) {
        return createMoneyFormatter(currency).format((Number(cents) || 0) / 100);
    }

    function escapeHtml(value) {
        return String(value || '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    function buildItemMarkup(item, currency) {
        var imageMarkup = item.image
            ? '<img class="vitalify-cart-item__image" src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" loading="lazy">'
            : '<span class="vitalify-cart-item__image vitalify-cart-item__image--empty">Produto</span>';

        var variantTitle = item.variant_title && item.variant_title !== 'Default Title'
            ? '<p class="vitalify-cart-item__variant">' + escapeHtml(item.variant_title) + '</p>'
            : '';

        return '' +
            '<article class="vitalify-cart-item" data-cart-item data-cart-item-key="' + escapeHtml(item.key) + '">' +
                '<a href="' + escapeHtml(item.url) + '" class="vitalify-cart-item__media">' + imageMarkup + '</a>' +
                '<div class="vitalify-cart-item__body">' +
                    '<a href="' + escapeHtml(item.url) + '" class="vitalify-cart-item__title">' + escapeHtml(item.product_title) + '</a>' +
                    variantTitle +
                    '<div class="vitalify-cart-item__controls">' +
                        '<span class="vitalify-cart-item__qty-label">QTY:</span>' +
                        '<div class="vitalify-cart-item__qty">' +
                            '<button type="button" class="vitalify-cart-item__qty-button" data-cart-quantity-change data-line-key="' + escapeHtml(item.key) + '" data-next-quantity="' + (item.quantity - 1) + '" aria-label="Diminuir quantidade">-</button>' +
                            '<span class="vitalify-cart-item__qty-value">' + item.quantity + '</span>' +
                            '<button type="button" class="vitalify-cart-item__qty-button" data-cart-quantity-change data-line-key="' + escapeHtml(item.key) + '" data-next-quantity="' + (item.quantity + 1) + '" aria-label="Aumentar quantidade">+</button>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
                '<div class="vitalify-cart-item__aside">' +
                    '<button type="button" class="vitalify-cart-item__remove" data-cart-remove data-line-key="' + escapeHtml(item.key) + '">Remover</button>' +
                    '<strong class="vitalify-cart-item__price">' + escapeHtml(formatMoney(item.final_line_price, currency)) + '</strong>' +
                '</div>' +
            '</article>';
    }

    function fetchCart() {
        return fetch(getRootUrl() + 'cart.js', {
            headers: {
                Accept: 'application/json'
            }
        }).then(function (response) {
            if (!response.ok) {
                throw new Error('Nao foi possivel carregar o carrinho.');
            }

            return response.json();
        });
    }

    function addToCart(payload) {
        return fetch(getRootUrl() + 'cart/add.js', {
            method: 'POST',
            headers: {
                Accept: 'application/json'
            },
            body: payload
        }).then(function (response) {
            if (!response.ok) {
                throw new Error('Nao foi possivel adicionar ao carrinho.');
            }

            return response.json();
        });
    }

    function updateCartItem(lineKey, quantity) {
        return fetch(getRootUrl() + 'cart/change.js', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: lineKey,
                quantity: Math.max(0, Number(quantity) || 0)
            })
        }).then(function (response) {
            if (!response.ok) {
                throw new Error('Nao foi possivel atualizar o carrinho.');
            }

            return response.json();
        });
    }

    function initCartDrawer(headerElement) {
        if (!headerElement || headerElement.dataset.cartDrawerInitialized === 'true') {
            return;
        }

        var drawerElement = headerElement.querySelector('[data-cart-drawer]');
        var itemsContainer = headerElement.querySelector('[data-cart-items]');
        var emptyState = headerElement.querySelector('[data-cart-empty]');
        var subtotalElement = headerElement.querySelector('[data-cart-subtotal]');
        var countBadge = headerElement.querySelector('[data-cart-count-badge]');
        var countTitle = headerElement.querySelector('[data-cart-title-count]');
        var checkoutButton = headerElement.querySelector('.vitalify-cart-drawer__checkout');
        var recommendationSliderElement = headerElement.querySelector('[data-cart-recommendations-slider]');
        var recommendationPaginationElement = headerElement.querySelector('[data-cart-recommendations-pagination]');
        var recommendationSection = headerElement.querySelector('[data-cart-recommendations]');
        var testimonialSliderElement = headerElement.querySelector('[data-cart-testimonials-slider]');
        var testimonialPaginationElement = headerElement.querySelector('[data-cart-testimonials-pagination]');
        var testimonialSection = headerElement.querySelector('[data-cart-testimonials]');
        var cartOpenButtons = headerElement.querySelectorAll('[data-cart-open]');
        var closeButtons = headerElement.querySelectorAll('[data-cart-close]');
        var recommendationSlider = null;
        var testimonialSlider = null;
        var isLoading = false;

        if (!drawerElement || !itemsContainer) {
            return;
        }

        headerElement.dataset.cartDrawerInitialized = 'true';

        function setScrollLocked(locked) {
            document.documentElement.style.overflow = locked ? 'hidden' : '';
        }

        function openDrawer() {
            drawerElement.hidden = false;
            drawerElement.setAttribute('aria-hidden', 'false');
            drawerElement.offsetHeight;
            drawerElement.classList.add('is-open');
            window.setTimeout(function () {
                if (recommendationSlider && typeof recommendationSlider.update === 'function') {
                    recommendationSlider.update();
                }

                if (testimonialSlider && typeof testimonialSlider.update === 'function') {
                    testimonialSlider.update();
                }
            }, 60);
            setScrollLocked(true);
            document.dispatchEvent(new CustomEvent('vitalify:cart:toggle', {
                detail: {
                    isOpen: true
                }
            }));
        }

        function closeDrawer() {
            drawerElement.classList.remove('is-open');
            drawerElement.setAttribute('aria-hidden', 'true');
            setScrollLocked(false);
            document.dispatchEvent(new CustomEvent('vitalify:cart:toggle', {
                detail: {
                    isOpen: false
                }
            }));

            window.setTimeout(function () {
                if (!drawerElement.classList.contains('is-open')) {
                    drawerElement.hidden = true;
                }
            }, 280);
        }

        function updateCounters(itemCount) {
            var count = Number(itemCount) || 0;

            if (countBadge) {
                countBadge.textContent = count;
                countBadge.hidden = count === 0;
            }

            if (countTitle) {
                countTitle.textContent = count;
            }
        }

        function updateSubtotal(totalPrice, currency) {
            if (subtotalElement) {
                subtotalElement.textContent = formatMoney(totalPrice, currency);
            }
        }

        function updateCheckoutState(itemCount) {
            if (!checkoutButton) {
                return;
            }

            var isEmpty = Number(itemCount) === 0;
            checkoutButton.classList.toggle('is-disabled', isEmpty);
            checkoutButton.setAttribute('aria-disabled', isEmpty ? 'true' : 'false');
            checkoutButton.tabIndex = isEmpty ? -1 : 0;
        }

        function renderItems(cart) {
            if (!cart || !cart.items) {
                return;
            }

            if (!cart.items.length) {
                itemsContainer.innerHTML = '';

                if (emptyState) {
                    emptyState.hidden = false;
                }
            } else {
                itemsContainer.innerHTML = cart.items.map(function (item) {
                    return buildItemMarkup(item, cart.currency);
                }).join('');

                if (emptyState) {
                    emptyState.hidden = true;
                }
            }

            updateCounters(cart.item_count);
            updateSubtotal(cart.total_price, cart.currency);
            updateCheckoutState(cart.item_count);

            document.dispatchEvent(new CustomEvent('vitalify:cart:updated', {
                detail: {
                    cart: cart
                }
            }));
        }

        function refreshCart(options) {
            return fetchCart().then(function (cart) {
                renderItems(cart);

                if (options && options.openDrawer) {
                    openDrawer();
                }

                return cart;
            });
        }

        function handleAddPayload(payload) {
            if (isLoading) {
                return;
            }

            isLoading = true;

            addToCart(payload)
                .then(function () {
                    return refreshCart({ openDrawer: true });
                })
                .catch(function () {
                    window.location.href = getRootUrl() + 'cart';
                })
                .finally(function () {
                    isLoading = false;
                });
        }

        cartOpenButtons.forEach(function (button) {
            button.addEventListener('click', function (event) {
                event.preventDefault();
                refreshCart({ openDrawer: true });
            });
        });

        closeButtons.forEach(function (button) {
            button.addEventListener('click', closeDrawer);
        });

        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') {
                closeDrawer();
            }
        });

        itemsContainer.addEventListener('click', function (event) {
            var quantityButton = event.target.closest('[data-cart-quantity-change]');
            var removeButton = event.target.closest('[data-cart-remove]');

            if (quantityButton) {
                var lineKey = quantityButton.getAttribute('data-line-key');
                var nextQuantity = Number(quantityButton.getAttribute('data-next-quantity') || '0');

                updateCartItem(lineKey, nextQuantity)
                    .then(function () {
                        return refreshCart();
                    })
                    .catch(function () {
                        return null;
                    });
            }

            if (removeButton) {
                var removeKey = removeButton.getAttribute('data-line-key');

                updateCartItem(removeKey, 0)
                    .then(function () {
                        return refreshCart();
                    })
                    .catch(function () {
                        return null;
                    });
            }
        });

        document.addEventListener('submit', function (event) {
            var form = event.target;

            if (!form || !form.matches('form[action*="/cart/add"]')) {
                return;
            }

            event.preventDefault();
            handleAddPayload(new FormData(form));
        });

        headerElement.addEventListener('click', function (event) {
            var addButton = event.target.closest('[data-cart-add]');

            if (!addButton) {
                return;
            }

            event.preventDefault();

            var variantId = addButton.getAttribute('data-variant-id');
            var quantity = Number(addButton.getAttribute('data-quantity') || '1');
            var payload = new FormData();

            payload.append('id', variantId);
            payload.append('quantity', quantity);

            handleAddPayload(payload);
        });

        function initRecommendationSlider() {
            if (!recommendationSliderElement || !window.VitalifySwiper) {
                return;
            }

            var slideCount = recommendationSliderElement.querySelectorAll('.swiper-slide').length;

            if (slideCount <= 1) {
                if (recommendationPaginationElement) {
                    recommendationPaginationElement.hidden = true;
                }

                return;
            }

            recommendationSlider = window.VitalifySwiper.create(recommendationSliderElement, {
                slidesPerView: 1,
                spaceBetween: 12,
                pagination: recommendationPaginationElement ? {
                    el: recommendationPaginationElement,
                    clickable: true
                } : undefined
            });
        }

        function initTestimonialSlider() {
            if (!testimonialSliderElement || !window.VitalifySwiper) {
                return;
            }

            var slideCount = testimonialSliderElement.querySelectorAll('.swiper-slide').length;

            if (slideCount <= 1) {
                if (testimonialPaginationElement) {
                    testimonialPaginationElement.hidden = true;
                }

                return;
            }

            testimonialSlider = window.VitalifySwiper.create(testimonialSliderElement, {
                slidesPerView: 1,
                spaceBetween: 12,
                speed: 650,
                pagination: testimonialPaginationElement ? {
                    el: testimonialPaginationElement,
                    clickable: true
                } : undefined,
                autoplay: {
                    delay: 5200,
                    disableOnInteraction: false
                }
            });
        }

        if (testimonialSection) {
            initTestimonialSlider();
        }

        if (recommendationSection) {
            initRecommendationSlider();
        }

        refreshCart();
    }

    window.VitalifyCartDrawer = {
        init: initCartDrawer,
        refresh: fetchCart
    };
})();
